<template>
  <div class="fillable-document">
    <v-img
      :src="require('@/assets/svg/confirmation-icon.svg')"
      class="mb-5 mt-5"
      height="140"
      contain
    />
    <div class="mb-5 text-center font-weight-bold">
      Candidate has not uploaded a file yet
    </div>

    <span class="font-weight-bold">
      Template
    </span>
    <FileComponent
      class="py-2"
      :file="document"
      customActions
      @show="showFile"
      disabled
    />
    <PDFViewFull :data="fileDialog" />
  </div>
</template>
<script>
import FileComponent from "@/components/common/FileComponent";
import { getFilePreviewSettings } from "@/utils/files";
import PDFViewFull from "@/components/common/PDFViewFull";

export default {
  components: {
    FileComponent,
    PDFViewFull
  },
  props: {
    document: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      fileDialog: { dialog: false }
    };
  },
  methods: {
    async showFile() {
      const filePreviewSettings = await getFilePreviewSettings(this.document);
      this.fileDialog = {
        ...filePreviewSettings,
        dialog: true
      };
    }
  }
};
</script>

<style lang="scss"></style>
